// Constant values for ads related values

export const LOTAME_SEGMENT_LIMIT_DEFAULT = 40;

export const LOTAME_SEGMENT_LIMIT_KEY = 'ads.lotame.segmentLimit';

export const VIDEO_PREROLL_DISABLE_SKIP_KEY =
  'ads.videoPreroll.disableSkipVideoPreroll';

export const PAUSE_PREROLL_ENABLED = 'ads.pause.preroll.enabled';

export const MOBILE_PREROLL_ENABLED = 'ads.mobilePreroll.isEnabled';

export const DONT_SELL_MY_DATA_ENABLED = 'ads.dontSellMyData.enabled';

export const DATA_OPT_OUT_ENABLED = 'ads.dataOptOut.enabled';

export const ALLOW_IP_ADDRESS_SHARING = 'ads.passLocation.enabled';

export const ONETRUST_ENABLED = 'ads.onetrust.gdpr.consent.form.enabled';
